/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectEntitlementsAndiChat
 */
export interface ProjectEntitlementsAndiChat {
    /**
     * True if Andi is available for this project.
     * @type {boolean}
     * @memberof ProjectEntitlementsAndiChat
     */
    value: boolean;
}

/**
 * Check if a given object implements the ProjectEntitlementsAndiChat interface.
 */
export function instanceOfProjectEntitlementsAndiChat(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ProjectEntitlementsAndiChatFromJSON(json: any): ProjectEntitlementsAndiChat {
    return ProjectEntitlementsAndiChatFromJSONTyped(json, false);
}

export function ProjectEntitlementsAndiChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectEntitlementsAndiChat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function ProjectEntitlementsAndiChatToJSON(value?: ProjectEntitlementsAndiChat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

